import React, { useState } from 'react';
import { Row } from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import HeroCard from '../HeroCard/HeroCard';
import ResponseInformation from './ResponseInformation';

export default function ExampleHeroCardResponse({ elem, reloadBotResponse, showFav, selectedLang, historyUpdator, isButtonShow }) {
  // console.log(elem);
  // console.log(reloadBotResponse)
  const [isAddMsg, setIsAddMsg] = useState(true);

  return (
    <Row>
      <Colxx xxs="12" xs="3">
        <ResponseInformation elem={elem} showFav={showFav} isRelicationResponse={false} selectedLang={selectedLang} historyUpdator={historyUpdator} />
      </Colxx>
      <Colxx xxs="12" xs="9">
        {isAddMsg ? (
          <Row>
            <Colxx md="12" className="mb-2">
              <HeroCard
                isAdd={isAddMsg}
                code={elem.query.code}
                type={elem.response.type}
                msg={''}
                messages={elem.response.messages}
                index={0}
                example={elem.response.example}
                setIsAddMsgToFalse={() => setIsAddMsg(false)}
                reloadBotResponse={reloadBotResponse}
                Title={elem.query.title}
                SubTitle={elem.query.subTitle}
                AllButtons={elem.query.buttons}
                isEditAble={false}
                imageUrl={''}
                link={''}
                selectedLang={selectedLang}
                historyUpdator={historyUpdator}
                isButtonShow={isButtonShow}
              />
            </Colxx>
          </Row>
        ) : null}
      </Colxx>
    </Row>
  );
}
